/**
 * Created by BFR on 02/03/2020.
 */
define('productShareTabController',[
  'module',
  'underscore',
  'app',
  'productShareTabView',
  'entities/product',
  'entities/product_share'
], function(
  module,
  _,
  App,
  View
) {

    'use strict';
  var ProductTranslationsController = {
    showDetails: function (region, pm) {
      var product = App.request('products:model', {secId: pm.get('secId')});
      this.model = product;

      var productShare = App.request('products-share:model', { secId: pm.get('secId') });
      productShare.fetch().done(_.bind(function() {
        App.request('product:get-last-checked-data', productShare.get('product').get('cCode')).done(_.bind(function (lastCheckedData) {
          this.view = new View({
            model: productShare,
            lastCheckedData: lastCheckedData
          });
          region.show(this.view);
        }, this));
      }, this));
    }
  };

  module.exports = ProductTranslationsController;
});
